<template>
  <div id="reserva">
    <vue-headful :title="$store.state.option['car_title-' + lang]" :lang="lang" />
    <titulo></titulo>

    <div class="container m-b-20 m-t-20">
      <h2 class="text-danger text-center p-50">{{$store.state.option['reserved-reserva-erro-n-' + lang]}} <span class="laranja">{{reserva}}</span>.

        <div class="p-t-30 text-center">
          <img alt="paypal" src="/img/paypal.png" style="max-width:100px" />
          <a :href="'/paypal/create-payment/' + reserva" class="btn btn-primary m-t-20 m-b-20 text-uppercase btn-block">{{$store.state.option['try-novamente-paypal-' + lang]}} <i class="fas fa-arrow-circle-right"></i></a>
        </div>

      </h2>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import titulo from '@/components/titulo'

export default {
  components: { titulo },
  data () {
    return {
      lang: '',
      reserva: ''
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_LOAD1',
      'SET_TITULO',
      'SET_SUBTITULO',
      'SET_AVISO'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.user1) {
        this.lang = this.$store.state.lang
        this.reserva = parseInt(window.location.search.split('id=')[1])
        this.SET_TITULO(this.$store.state.option['failed_title-' + this.lang])
        this.SET_SUBTITULO(this.$store.state.option['failed_subtitle-' + this.lang])
        this.SET_LOAD()
        this.SET_LOAD1()
      } else {
        this._.delay(this.init, 100)
      }
    }
  }
}
</script>
